import {
	Box,
	CircularProgress,
	Grid2,
	IconButton,
	Typography,
} from '@mui/material';
import { DeleteIcon, FileIcon, LinkIcon } from '../../assets/icons/Icons';
import { MAIN_THEME_COLOR } from '../../assets/theme/Colors';

const TABS = {
	doc: 'Documents',
	url: 'Websites',
};

interface FileOverviewProps {
	tab: string;
	data: string[];
	onPressRemoveItem: (value: string) => void;
	isLoading: boolean;
}

function FileOverview({
	tab,
	data,
	onPressRemoveItem,
	isLoading,
}: FileOverviewProps) {
	if (isLoading) {
		return (
			<Grid2
				container
				width={'100%'}
				height={'50vh'}
				justifyContent={'center'}
				alignItems={'center'}>
				<CircularProgress sx={{ color: MAIN_THEME_COLOR }} />
			</Grid2>
		);
	} else {
		return (
			<Box
				sx={{
					overflowY: 'auto',
					height: '55vh',
					width: '100%',
					'&::-webkit-scrollbar': {
						display: 'none', // Hide the scrollbar for WebKit browsers (Chrome, Safari, Edge, etc.)
					},
					'&-ms-overflow-style:': {
						display: 'none', // Hide the scrollbar for IE
					},
				}}>
				{data && data.length > 0 ? (
					data.map((item, index) => {
						return (
							<Grid2
								container
								key={index}
								alignItems="center"
								sx={{
									backgroundColor: '#F5F5F5',
									padding: '10px',
									marginX: '10px',
									marginBottom: '5px',
									borderRadius: '5px',
								}}>
								<Grid2
									size={{ xs: 1 }}
									display="flex"
									justifyContent="center"
									alignItems="center">
									{tab === TABS.url ? (
										<LinkIcon />
									) : (
										<FileIcon />
									)}
								</Grid2>
								<Grid2
									size={{ xs: 10 }}
									sx={{ paddingX: '10px' }}>
									<Typography
										fontSize="12px"
										color="#000"
										sx={{
											wordBreak: 'break-word',
										}}>
										{item}
									</Typography>
								</Grid2>
								<Grid2
									size={{ xs: 1 }}
									display="flex"
									justifyContent="flex-end">
									<IconButton
										onClick={() => onPressRemoveItem(item)}>
										<DeleteIcon />
									</IconButton>
								</Grid2>
							</Grid2>
						);
					})
				) : (
					<Typography
						textAlign={'center'}
						fontSize={'14px'}
						paddingY={'10px'}>
						No data
					</Typography>
				)}
			</Box>
		);
	}
}

export default FileOverview;
